<template>
  <div class="bg-white">
    <v-container fluid>
      <h4 class="mt-3 text-dark">DISPONIBILIDAD DE PROXIMOS ARRIBOS</h4>
      <search-input
        v-model="search"
        :disabled="upcomingArrivals.loading"
        class="w-25"
        @onSearch="searchUpcomingArrivals"
      />

      <upcoming-arrivals-table
        :items="upcomingArrivals.data"
        :loading="upcomingArrivals.loading"
      />
      <v-alert
        class="my-4"
        text
        color="info"
        icon="mdi-alert-outline"
        border="left"
      >
        La consulta de la vista es únicamente a códigos Genética A, B y N.
      </v-alert>

      <div class="text-black text-left">
        **
        <v-icon color="#000000" class="mx-3">mdi-alert-circle-outline</v-icon>
        Fechas de arribo no disponible
        <b>
          :(favor de contactar a
          <a
            class="font-weight-bold"
            href="mailto:planeacionlogistica@iusa.com.mx"
          >
            planeacionlogistica@iusa.com.mx
          </a>
          ) **
        </b>
      </div>
    </v-container>
    <confidentiality-notice class="mt-auto" />
  </div>
</template>
<script>
  import axios from '@/plugins/axios';
  import SearchInput from '@/components/SearchInput.vue';
  import ConfidentialityNotice from '@/components/ConfidentialityNotice.vue';
  import UpcomingArrivalsTable from './components/UpcomingArrivalsTable.vue';

  export default {
    name: 'UpcomingArrivalsView',
    components: {
      SearchInput,
      ConfidentialityNotice,
      UpcomingArrivalsTable,
    },
    data: () => ({
      search: '',
      upcomingArrivals: {
        data: [],
        loading: false,
      },
    }),
    methods: {
      async searchUpcomingArrivals() {
        const searchTerm = this.search?.trim();
        if (!searchTerm) {
          this.$toast.error('El campo de búsqueda es obligatorio');
          return;
        }
        try {
          this.upcomingArrivals.loading = true;
          const params = {
            search: searchTerm,
          };
          const response = await axios.get('/orders/upcoming-arrivals/search', {
            params,
          });
          this.upcomingArrivals.data = response.data;
        } catch (error) {
          this.upcomingArrivals.data = [];
          this.$toast.error('Hubo problemas al cargar la información');
        } finally {
          this.upcomingArrivals.loading = false;
        }
      },
    },
  };
</script>
